import { render, staticRenderFns } from "./WpReviewerCommentFields.vue?vue&type=template&id=80df35fe&scoped=true&"
import script from "./WpReviewerCommentFields.vue?vue&type=script&lang=js&"
export * from "./WpReviewerCommentFields.vue?vue&type=script&lang=js&"
import style0 from "./WpReviewerCommentFields.vue?vue&type=style&index=0&id=80df35fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80df35fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80df35fe')) {
      api.createRecord('80df35fe', component.options)
    } else {
      api.reload('80df35fe', component.options)
    }
    module.hot.accept("./WpReviewerCommentFields.vue?vue&type=template&id=80df35fe&scoped=true&", function () {
      api.rerender('80df35fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpReviewerCommentFields.vue"
export default component.exports